import subjectPlanOverviewEn from "./locales/en.json";

export const SUBJECT_PLAN_OVERVIEW_NS = "subjectPlanOverview" as const;

export const SubjectPlanPageTranslations = {
  en: {
    [SUBJECT_PLAN_OVERVIEW_NS]: {
      ...subjectPlanOverviewEn,
    },
  },
};
